import type { FC, JSX } from 'react'

import cn from 'clsx'

import s from './amount.module.scss'

export type AmountProps = {
  page: number
  total: number
  className?: string
}
const Amount: FC<AmountProps> = ({ page, total, className }): JSX.Element => {
  const classes = cn(s.root, className)
  const max = Math.min(total, 1000)

  if (total === 0) {
    return <></>
  }

  return (
    <div className={classes} data-testid="amount">
      <span>{`Jobs ${(page - 1) * 10 + 1} - ${Math.min(page * 10, max)} of ${max}`}</span>
    </div>
  )
}

export default Amount
